import script from "./ModalMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMain.vue?vue&type=script&setup=true&lang=js"

import "./ModalMain.vue?vue&type=style&index=0&id=4683239c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4683239c"]])

export default __exports__